interface PlaceholderPageProps {
  title: string
  description?: string
}

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <div className="flex h-full flex-col">
      <header className="mb-6 border-b border-border/60 pb-4">
        <h1 className="text-xl font-semibold text-foreground">{title}</h1>
        {description && <p className="mt-1 text-sm text-muted">{description}</p>}
      </header>
      <div className="flex flex-1 items-center justify-center rounded-md border border-dashed border-border/60 text-sm text-muted">
        Coming in Sprint 1
      </div>
    </div>
  )
}
